export default [
    {
        path: '/proposal/payment-term/overdue',
        props: true,
        component: () => import('@/views/Proposal/PaymentTerm'),
    },
];
